import React from 'react';

import { Icon } from '@chakra-ui/react';

export const MachineImageIcon = props => (
  <Icon viewBox="0 0 50 49" w="full" h="full" color="inherit" {...props}>
    <defs>
      <clipPath id="clip0">
        <rect x="588" y="123" width="50" height="49" />
      </clipPath>
    </defs>
    <g clip-path="url(#clip0)" transform="translate(-588 -123)">
      <path
        d="M41.209 47.53 7.84 47.53C4.34911 47.5571 1.49725 44.7491 1.47019 41.2582 1.47006 41.2418 1.47 41.2254 1.47 41.209L1.47 7.84C1.44283 4.34911 4.25073 1.49717 7.74162 1.47 7.77441 1.46975 7.80721 1.46975 7.84 1.47L41.258 1.47C44.7489 1.49696 47.557 4.34873 47.53 7.83962 47.53 7.83975 47.53 7.83987 47.53 7.84L47.53 41.258C47.5031 44.7298 44.6809 47.5301 41.209 47.53ZM7.84 3.43C5.42617 3.40825 3.45175 5.34742 3.43 7.76125 3.42976 7.7875 3.42976 7.81375 3.43 7.84L3.43 41.258C3.46228 43.6643 5.4336 45.5918 7.84 45.57L41.258 45.57C43.6643 45.5646 45.6136 43.6153 45.619 41.209L45.619 7.84C45.6407 5.42617 43.7016 3.45175 41.2878 3.43 41.2615 3.42976 41.2353 3.42976 41.209 3.43Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M41.0424 21.805 7.9576 21.805C7.41636 21.805 6.9776 21.3662 6.9776 20.825L6.9776 9.8C6.9776 9.25876 7.41636 8.82 7.9576 8.82L41.0424 8.82C41.5836 8.82 42.0224 9.25876 42.0224 9.8L42.0224 20.825C42.0224 21.3662 41.5836 21.805 41.0424 21.805ZM8.9376 19.845 40.0624 19.845 40.0624 10.78 8.9376 10.78Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M41.0424 41.1012 7.9576 41.1012C7.41636 41.1012 6.9776 40.6624 6.9776 40.1212L6.9776 26.3424C6.9776 25.8012 7.41636 25.3624 7.9576 25.3624L41.0424 25.3624C41.5836 25.3624 42.0224 25.8012 42.0224 26.3424L42.0224 40.1212C42.0224 40.6624 41.5836 41.1012 41.0424 41.1012ZM8.9376 39.1412 40.0624 39.1412 40.0624 27.3224 8.9376 27.3224Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M18.0124 9.8 19.9724 9.8 19.9724 20.825 18.0124 20.825Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M29.0374 9.8 30.9974 9.8 30.9974 20.825 29.0374 20.825Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M18.0124 26.3424 19.9724 26.3424 19.9724 40.1212 18.0124 40.1212Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M29.0374 26.3424 30.9974 26.3424 30.9974 40.1212 29.0374 40.1212Z"
        fill="currentColor"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
      <path
        d="M-34.3-6.37 276.36-6.37 287.473 1567.51 127.606 1567.51 127.665 1638.56-47.04 1638.56-34.3-6.37Z"
        stroke="currentColor"
        strokeWidth="2.94"
        strokeMiterlimit="10"
        fill="none"
        transform="matrix(1.02041 0 0 1 588 123)"
      />
    </g>
  </Icon>
);
